<template>
  <div class="chat-app">
    <!-- <div class="chat-list"> -->
    <!-- <div class="chat-header">Lista de Tickets</div> -->
    <!-- Lista de chats a la izquierda -->
    <!-- <div class="chat-item">Tickets 1</div> -->
    <!-- <div class="chat-item">Tickets 2</div>
      <div class="chat-item">Tickets 3</div>
      <div class="chat-item">Tickets 4</div> -->
    <!-- Agrega más chats aquí -->
    <!-- </div> -->
    <div v-if="filePreview" class="preview-sidebar">
      <div class="preview-header">Adjuntos</div>
      <div class="card-previsualizacion">
        <div class="preview-body">
          <vs-button class=" bg-danger eliminar-adjunto" @click="eliminarAdjunto()" v-b-tooltip.hover
            title="Eliminar adjunto">
            <i class="fa-solid fa-trash"></i>
          </vs-button>
          <!-- Imagen -->
          <div v-if="fileType.startsWith('image/')" class="imagen-contenedor">
            <img :src="filePreview" alt="Previsualización de imagen" class="imagen-previa" data-aos="zoom-in" />
          </div>

          <!-- Video -->
          <div v-else-if="fileType.startsWith('video/')" class="video-contenedor">
            <video controls :src="filePreview" class="video-previo" data-aos="zoom-in"></video>
          </div>

          <!-- Audio -->
          <div v-else-if="fileType.startsWith('audio/')" class="audio-contenedor">
            <audio controls :src="filePreview"></audio>
          </div>

          <!-- PDF -->
          <div v-else-if="fileType === 'application/pdf'" class="pdf-contenedor">
            <iframe :src="filePreview" class="pdf-previo"></iframe>
          </div>

          <!-- Texto plano -->
          <div v-else-if="fileType.startsWith('text/')" class="texto-contenedor">
            <pre class="texto-previo">{{ textPreview }}</pre>
          </div>

          <!-- Sin previsualización -->
          <div v-else class="mensaje-sin-imagen">
            <i class="fa-solid fa-file-circle-xmark fa-3x mb-2"></i>
            <p class="mb-0">Previsualización no disponible</p>
            <small>{{ file?.name }}</small>
          </div>
        </div>
      </div>
    </div>

    <div class="chat">
      <div class="chat-header bg-primary d-flex align-items-center">
        <button @click="regresar" class="btn btn-sm btn-danger">
          <i class="fas fa-arrow-left"></i> Volver
        </button>
        <h3 class="chat-title text-white">Tickets</h3>
      </div>
      <div class="chat-messages">
        <div v-for="(message, index) in messages" :key="index"
          :class="(usuario.id == message.deId ? ' sent-message ' : ' received-message ') + ' message-bubble'">

          <div class="message-author ">
            <span v-if="usuario.id != message.deId">{{ message.de.nombres + " " +
              message.de.apellidos }}</span>
            <span class="text-white" v-else>{{ usuario.nombres + " " + usuario.apellidos }}</span>
          </div>

          <div class="message-content">{{ message.mensaje }}</div>

          <div v-if="message.urlAdjunto != null" class="message-attachment">
            <div class="attachment-image">
              <ContenidoHelexium :fileId="message.urlAdjunto" />
            </div>
            <!-- <img :src="message.urlAdjunto" class="attachment-image" alt=""
                v-if="['jpg', 'peg', 'png', 'bmp', 'gif'].includes(message.urlAdjunto.substr(message.urlAdjunto.length - 3))">
              <img v-else src="/img/viewfile.png" class="attachment-icon" alt="" v-b-tooltip.top
                title="click para ver / descargar archivo"> -->
          </div>

          <div class="message-time">
            {{ $moment.tz(message.fecha, "America/Bogota").fromNow() }}
          </div>
        </div>
        <span style="color: #102444 !important" ref="chatmessages">_</span>
      </div>
      <div class="message-input-container">
        <input ref="fileInput" id="file-upload" type="file" @change="handleFileUpload" hidden />

        <button @click="uploadImage()" class="upload-button" v-b-tooltip.top title="Subir archivo">
          <img src="/img/icons/subir-archivo.png" width="24" alt="">
        </button>

        <input v-model="mensaje" class="message-input" placeholder="Escribe un mensaje..." />

        <button @click="enviarMensaje()" class="send-button" :disabled="enviando">
          <span v-if="!enviando" class="text-white">Enviar</span>
          <i v-if="enviando" class="fas fa-spinner fa-spin"></i>
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import ContenidoHelexium from "../../../components/helexium/ContenidoHelexium.vue";
export default {
  components: {
    ContenidoHelexium,
  },
  sockets: {
    connect: function () {
      console.log(
        "conectado a cockets. en app.vue***************************************************************"
      );
    },
    nuevo_mensaje: async function (data) {
      let usuario = JSON.parse(localStorage.getItem("setPersonaAct")) || null;
      console.log(data);
      if (usuario != null) {
        if (
          data.ParaId == usuario.id ||
          (data.ParaId == null && usuario.rol.nivel == 4)
        ) {
          this.getData();
        }
      }
    },
  },
  data() {
    return {
      enviando: false,
      personaId: null,
      usuario: {},
      id: null,
      ticketPersonaNombre: "Tickets",
      messages: [
        // { text: "Mensaje enviado", type: "sent" },
        // { text: "Mensaje recibido", type: "received" },
        // Agrega más mensajes aquí con sus respectivos tipos
      ],
      mensaje: "",
      Detalle: {
        Id: null,
        TicketId: null,
        urlAdjunto: null,
        DeId: null,
        ParaId: null,
        Mensaje: null,
        Fecha: null,
        Leido: false,
      },
      files: null,
      filelist: [],
      file1: null,
      filename: null,
      file: null,
      filePreview: null,
    };
  },
  async mounted() {
    this.usuario = JSON.parse(localStorage.getItem("setPersonaAct"));

    this.id = this.$route.params.id;
    this.personaId = this.$route.params.userid;

    // Obtener el nombre desde los query params si existe
    if (this.$route.query.nombre) {
      this.ticketPersonaNombre = this.$route.query.nombre;
    }

    await this.getData();
  },
  methods: {
    uploadImage() {
      this.$refs.fileInput.click();
    },
    clearVarFiles() {
      this.file1 = null;
      this.filename = null;
      this.files = [];
      this.filelist = [];
      this.Detalle = { Id: null, TicketId: null, urlAdjunto: null, DeId: null, ParaId: null, Mensaje: null, Fecha: null, Leido: false }
    },
    eliminarAdjunto() {
      this.file = null;
      this.filePreview = null;
      this.fileType = null;
      this.textPreview = "";
    },
    handleFileUpload(event) {
      this.file = event.target.files[0];
      if (!this.file) return;

      this.fileType = this.file.type;
      this.textPreview = "";
      this.filePreview = null;

      if (
        this.fileType.startsWith("image/") ||
        this.fileType.startsWith("video/") ||
        this.fileType.startsWith("audio/") ||
        this.fileType === "application/pdf"
      ) {
        this.filePreview = URL.createObjectURL(this.file);
      }

      else if (this.fileType.startsWith("text/")) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.textPreview = e.target.result;
          this.filePreview = "text";
        };
        reader.readAsText(this.file);
      }

      else {
        this.filePreview = "no-preview";
      }
    },

    async renameFile(nameFile) {
      this.realName = nameFile;
      let collectionBad = "á é í ó ú Á É Í Ó Ú ñ Ñ";
      let collectionGood = "a e i o u A E I O U n N";
      let collectionBadA = collectionBad.split(" ");
      let collectionGoodA = collectionGood.split(" ");
      let count = 0;
      for await (let it of collectionBadA) {
        let pos = nameFile.indexOf(it);
        if (pos > 0) {
          nameFile = nameFile.replaceAll(it, collectionGoodA[count]);
        }
        pos = 0;
        count++;
      }
      return nameFile;
    },
    async uploadImagenPerfilDrive(ticketId) {
      try {
        if (!this.file) {
          throw new Error("No hay archivo para subir.");
        }

        // Nombre final (sin tildes ni espacios)
        const filename = `${ticketId} - ${this.file.name}`;
        const urlImg = `SoporteTickets/${this.usuario.empresa.nombre.replace(/\s/g, "")}`;
        const chunkSize = 5 * 1024 * 1024;
        const totalChunks = Math.ceil(this.file.size / chunkSize);
        const uploadId = crypto.randomUUID();

        let driveFileId = null;

        for (let chunkNumber = 1; chunkNumber <= totalChunks; chunkNumber++) {
          const start = (chunkNumber - 1) * chunkSize;
          const end = Math.min(start + chunkSize, this.file.size);
          const chunkBlob = this.file.slice(start, end);

          const formData = new FormData();
          formData.append("chunk", chunkBlob);
          formData.append("chunkNumber", chunkNumber);
          formData.append("totalChunks", totalChunks);
          formData.append("uploadId", uploadId);
          formData.append("fileName", filename);
          formData.append("remoteFilePath", urlImg);
          formData.append("fileType", this.file.type);

          const res = await this.$store.dispatch("hl_post_file_axios", {
            path: "CargaMultimedia/UploadChunkDrive",
            data: formData,
            onProgress: (percent) => {
              const globalPercent = Math.floor(
                ((chunkNumber - 1) / totalChunks) * 100 + percent / totalChunks
              );
              this.progreso = globalPercent;
              console.log(`Subiendo chunk ${chunkNumber}/${totalChunks}: ${globalPercent}%`);
            },
          });

          if (!res.respuesta) {
            throw new Error(res.mensaje || `Error al subir chunk ${chunkNumber}`);
          }

          if (res.data) {
            driveFileId = res.data;
          }
        }

        if (!driveFileId) throw new Error("No se obtuvo el ID de Drive.");

        const driveUrl = `${driveFileId}`;
        return driveUrl;

      } catch (error) {
        console.error("Error en la subida a Drive:", error);
        throw error;
      }
    },

    scrollFix: function () {
      setTimeout(() => {
        const el = this.$refs.chatmessages;
        el.scrollIntoView({ behavior: "smooth", block: "end" });
        console.log("ok");
      }, 1000);
    },
    async getData() {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "PersonaTicket/GetByTicket/" + this.id,
        });
        console.log(res);
        if (res.length > 0) {
          this.messages = res;

          // Solo actualizar el nombre si no se pasó como parámetro
          if (!this.$route.query.nombre) {
            // Obtener el nombre de la otra persona (no el usuario actual)
            for (let message of res) {
              if (message.de && message.deId !== this.usuario.id) {
                const personaDe = message.de;
                this.ticketPersonaNombre =
                  `${personaDe.nombres || ""} ${personaDe.apellidos || ""
                    }`.trim() || "Tickets";
                break; // Encontramos la otra persona, salimos del loop
              }
            }

            // Si todos los mensajes son del usuario actual, usar el primer mensaje
            if (this.ticketPersonaNombre === "Tickets" && res[0] && res[0].de) {
              const personaDe = res[0].de;
              this.ticketPersonaNombre =
                `${personaDe.nombres || ""} ${personaDe.apellidos || ""
                  }`.trim() || "Tickets";
            }
          }

          this.scrollFix();
        } else {
          this.messages = [];
        }
      } catch (error) {
        this.messages = [];
        console.log("err", error);
      }
    },
    async enviarMensaje() {
      if (this.mensaje.trim() == "") {
        this.showToast("warning", "No puedes enviar mensajes vacíos.");
        return;
      }
      try {
        console.log("Enviando mensaje");

        this.enviando = true;
        if (this.usuario.rol.nivel == 4) {
          this.Detalle.ParaId = this.personaId;
        }
        this.Detalle.DeId = this.usuario.id;
        this.Detalle.TicketId = this.id;
        this.Detalle.Fecha = this.$moment
          .tz(new Date(), "America/Bogota")
          .format("YYYY-MM-DDTHH:mm");
        this.Detalle.Mensaje = this.mensaje;
        this.$store.e;
        if (this.file != null) {

          console.log("Enviando mensaje 3", this.file);
          this.Detalle.urlAdjunto = await this.uploadImagenPerfilDrive(this.id);
        }
        console.log(this.Detalle);
        let dataMensaje = await this.$store.dispatch("hl_post", {
          path: "PersonaTicket/NuevoTicketDetalle",
          data: this.Detalle,
        });
        /////////////
        //enviar mensaje socket
        let dataMensajeSocket = await this.$store.dispatch("postw", {
          path: "enviarNotificacion",
          data: this.Detalle,
        });
        console.log("socket enviando", dataMensajeSocket);
        ////////////////////////
        let dataCorreo = {};
        if (this.usuario.rol.nivel == 4) {
          dataCorreo = {
            Correo: this.usuario.correo, // "absanchezmena@gmail.com", // enviar correo a usuario
            Asunto: "Nuevo mensaje...",
            Mensaje: this.Detalle.Mensaje,
          };
        } else {
          dataCorreo = {
            Correo: "Info@helexium.cloud", // "absanchezmena@gmail.com", // enviar correo a admin helex
            Asunto: "Nuevo mensaje...",
            Mensaje: this.Detalle.Mensaje,
          };
        }
        await this.$store.dispatch("hl_post", {
          path: "Persona/EnvioNotificacionCorreoCustom",
          data: dataCorreo,
        });
        //////////////////////
        console.log(dataMensaje);
        this.eliminarAdjunto();
        this.mensaje = "";
        this.enviando = false;
        this.getData();
        this.$store.commit("refrescarChat", 0);
        this.clearVarFiles();
        this.scrollFix();
      } catch (error) {
        this.enviando = false;
      }
    },

    showToast(type, message) {
      console.log(type);

      const opcionesBase = {
        position: "top-center",
        closeOnClick: true,
        pauseOnFocusLoss: false,
        pauseOnHover: false,
        draggable: false,
        draggablePercent: 0.41,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: "button",
        icon: true,
        rtl: false,
      };

      const tipos = {
        success: {
          metodo: this.$toast.success,
          timeout: 2984,
        },
        error: {
          metodo: this.$toast.error,
          timeout: 1992,
        },
        warning: {
          metodo: this.$toast.warning,
          timeout: 2984,
        },
      };

      if (tipos[type]) {
        tipos[type].metodo(message, {
          ...opcionesBase,
          timeout: tipos[type].timeout,
        });
      }
    },
    regresar() {
      this.$router.push("/helex/Tickets");
    },
  },



};
</script>

<style scoped>
/* ===== MODO CLARO ===== */
.chat-app {
  display: flex;
  max-width: 90%;
  height: 90vh;
  margin: 0 auto;
  gap: 1rem;
  background-color: #f5f7fa;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.preview-sidebar {
  width: 280px;
  background-color: #ffffff;
  border-right: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  padding: 1rem;
}

.preview-header {
  background-color: #ffffff;
  color: #1f2937;
  padding: 1rem;
  font-weight: 600;
  font-size: 1.1rem;
  border-bottom: 2px solid #e5e7eb;
  margin: -1rem -1rem 1rem -1rem;
}

.card-previsualizacion {
  width: 100%;
  height: 280px;
  overflow: hidden;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  background-color: #f9fafb;
  transition: all 0.3s ease;
}

.card-previsualizacion:hover {
  border-color: #3b82f6;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
}

.preview-body {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.eliminar-adjunto {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 10;
}

.imagen-contenedor {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 0.5rem;
}

.imagen-previa {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 8px;
}

.mensaje-sin-imagen {
  color: #9ca3af;
  text-align: center;
  padding: 2rem;
}

.fa-image-slash {
  color: #d1d5db;
}

.chat {
  background-image: url("/img/chat-2.png");
  background-repeat: repeat;
  flex: 1;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  overflow: hidden;
}

.chat-header {
  padding: 1.25rem 1.5rem;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.2);
  gap: 0.5rem;
}

.chat-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.chat-messages {
  flex: 1;
  padding: 1.5rem;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.chat-messages::-webkit-scrollbar {
  width: 8px;
}

.chat-messages::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 10px;
}

.chat-messages::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}

.chat-messages::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.message-bubble {
  max-width: 70%;
  padding: 0.875rem 1.125rem;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  animation: slideIn 0.3s ease;
  word-wrap: break-word;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.sent-message {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: #ffffff;
  align-self: flex-end;
  border-bottom-right-radius: 4px;
}

.received-message {
  background-color: #f1f5f9;
  color: #1e293b;
  align-self: flex-start;
  border-bottom-left-radius: 4px;
}

.message-author {
  font-size: 0.8rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  opacity: 0.9;
}

.message-content {
  font-size: 0.95rem;
  line-height: 1.5;
  margin-bottom: 0.5rem;
}

.message-attachment {
  text-align: center;
  margin: 0.75rem 0;
}

.attachment-link {
  display: inline-block;
  transition: transform 0.2s ease;
}

.attachment-link:hover {
  transform: scale(1.05);
}

.attachment-image {
  width: 30vw;
  height: 40vh;
  border-radius: 8px;
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.attachment-icon {
  width: 50px;
  height: 50px;
}

.message-time {
  font-size: 0.7rem;
  opacity: 0.7;
  text-align: right;
  margin-top: 0.25rem;
  font-style: italic;
}

.message-input-container {
  display: flex;
  align-items: center;
  padding: 1rem 1.5rem;
  background-color: #ffffff;
  border-top: 1px solid #e5e7eb;
  gap: 0.75rem;
}

.upload-button {
  padding: 0.625rem;
  background-color: #f1f5f9;
  color: #475569;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  height: 44px;
}

.upload-button:hover {
  background-color: #e2e8f0;
  border-color: #cbd5e1;
  transform: translateY(-1px);
}

.upload-button:active {
  transform: translateY(0);
}

.message-input {
  flex: 1;
  padding: 0.75rem 1rem;
  color: #1e293b;
  background-color: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 0.95rem;
  transition: all 0.2s ease;
}

.message-input:focus {
  outline: none;
  border-color: #3b82f6;
  background-color: #ffffff;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.message-input::placeholder {
  color: #94a3b8;
}

.send-button {
  padding: 0.75rem 1.5rem;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: #ffffff;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.95rem;
  transition: all 0.2s ease;
  min-width: 90px;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
}

.send-button:hover:not(:disabled) {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
}

.send-button:active:not(:disabled) {
  transform: translateY(0);
}

.send-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ===== MODO OSCURO ===== */
.dark .chat-app {
  background-color: #0f172a;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.dark .preview-sidebar {
  background-color: #1e293b;
  border-right: 1px solid #334155;
}

.dark .preview-header {
  background-color: #1e293b;
  color: #f1f5f9;
  border-bottom: 2px solid #334155;
}

.dark .card-previsualizacion {
  border: 2px solid #334155;
  background-color: #0f172a;
}

.dark .card-previsualizacion:hover {
  border-color: #3b82f6;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
}

.dark .mensaje-sin-imagen {
  color: #64748b;
}

.dark .fa-image-slash {
  color: #475569;
}

.dark .chat {
  background-image: url("/img/chat.png");
  background-color: #1e293b;
}



.dark .chat-messages::-webkit-scrollbar-track {
  background: #1e293b;
}

.dark .chat-messages::-webkit-scrollbar-thumb {
  background: #475569;
}

.dark .chat-messages::-webkit-scrollbar-thumb:hover {
  background: #64748b;
}

.dark .sent-message {
  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
  color: #ffffff;
}

.dark .received-message {
  background-color: #334155;
  color: #f1f5f9;
}

.dark .message-input-container {
  background-color: #1e293b;
  border-top: 1px solid #334155;
}

.dark .upload-button {
  background-color: #334155;
  color: #cbd5e1;
  border: 2px solid #475569;
}

.dark .upload-button:hover {
  background-color: #475569;
  border-color: #64748b;
}

.dark .message-input {
  color: #f1f5f9;
  background-color: #0f172a;
  border: 2px solid #334155;
}

.dark .message-input:focus {
  border-color: #3b82f6;
  background-color: #1e293b;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
}

.dark .message-input::placeholder {
  color: #64748b;
}

.dark .send-button {
  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.4);
}

.dark .send-button:hover:not(:disabled) {
  background: linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.5);
}

/* Responsividad */
@media (max-width: 768px) {
  .chat-app {
    max-width: 100%;
    height: 85vh;
    flex-direction: column;
    border-radius: 0;
  }

  .preview-sidebar {
    width: 100%;
    max-height: 200px;
    border-right: none;
    border-bottom: 1px solid #e5e7eb;
  }

  .dark .preview-sidebar {
    border-bottom: 1px solid #334155;
  }

  .message-bubble {
    max-width: 85%;
  }

  .message-input-container {
    padding: 0.75rem 1rem;
  }

  .attachment-image {
    width: 50vw;
    border-radius: 8px;
    border: 2px solid rgba(255, 255, 255, 0.3);
  }
}
</style>